import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { backendUrl } from 'src/environments/environment';
import { toPromise } from './toPromise';

export interface ProductPayload {
  product_name: string;
  category: number;
  subcategory: number;
  product_price: number;
  actual_price: number;
  product_description: string;
  product_condition: number;
  is_avail_delivery: number;
  is_avail_pickup: number;
  storage_locations: number;
  pickup_locations: number;
  sku: string;
  inventory: number;
  product_variation: Array<ProductVariation>;
  product_img: Array<ProductImg>;
  product_fields: Array<ProductFields>;
  status: number;
  video_thumbnail: string;
  video_full: string;
  video_id: number;
  target_audience: number;
  is_rentable: number;
  rental_price: number;
  when_return_days: number;
}

export interface ProductVariation {
  id: number;
  variation_name: string;
  variant: Array<Variant>;
}

export interface Variant {
  img?: string;
  variation_type?: number;
  variation_name?: string;
  variation_fields: Array<VariantField>;
  id: number;
}

export interface VariantField {
  variation_price?: number;
  size_type?: string;
  inventory?: number;
  sku?: string;
  id: number;
}
export interface ProductImg {
  thumbnail: string;
  full: string;
  type: number;
  id: number;
}

export interface ProductFields {
  field_title: string;
  field_input: string;
  id: number;
}

export interface Variations {
  data: Array<Variation>;
  status: number;
}

export interface Variation {
  created_at: string;
  deleted_at: string;
  id: number;
  seller_id: number;
  updated_at: string;
  variation_name: string;
}

export interface VariationName {
  variation_name: string;
}

@Injectable({
  providedIn: 'root',
})
export class SellerProductStore {
  constructor(private httpClient: HttpClient) {}

  async getVariations(): Promise<Variations> {
    const url = `${backendUrl}seller/variation`;
    const token = localStorage.getItem('authToken');
    return toPromise(
      this.httpClient.get<Variations>(url, {
        headers: new HttpHeaders({
          Authorization: `Bearer ${token}`,
        }),
      })
    );
  }

  async addSellerProduct(params: ProductPayload): Promise<ProductPayload> {
    const url = `${backendUrl}seller/product`;
    const token = localStorage.getItem('authToken');
    return toPromise(
      this.httpClient.post<ProductPayload>(url, params, {
        headers: new HttpHeaders({
          Authorization: `Bearer ${token}`,
        }),
      })
    );
  }

  async editSellerProduct(
    params: ProductPayload,
    productId: number
  ): Promise<ProductPayload> {
    const url = `${backendUrl}seller/product/${productId}`;
    const token = localStorage.getItem('authToken');
    return toPromise(
      this.httpClient.patch<ProductPayload>(url, params, {
        headers: new HttpHeaders({
          Authorization: `Bearer ${token}`,
        }),
      })
    );
  }

  async addVariationName(params: VariationName): Promise<VariationName> {
    const url = `${backendUrl}seller/variation`;
    const token = localStorage.getItem('authToken');
    return toPromise(
      this.httpClient.post<VariationName>(url, params, {
        headers: new HttpHeaders({
          Authorization: `Bearer ${token}`,
        }),
      })
    );
  }
}
